const Map = function(sidebar) {
  mapboxgl.accessToken = 'pk.eyJ1IjoiY29kd3JkaXYyIiwiYSI6ImNqbjBrcWhuMTFhNzYzcHJvZ2dmZTZ5cm4ifQ.nw2GqXAYKrVliTBQzhOaAg';
  const map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/codwrdiv2/cjn0m43ct4syx2snubwi9pbxt',
    center: [-103.579010, 38.196058],
    zoom: 7.8
  });

  map.on("load", () => {
    map.setLayoutProperty("div2-gages-filtered-hover", "visibility", "none");
  });

  // Create an instance of the activeLoc class
  const loc = new activeLoc();

  // Create a popup, but don't add it to the map yet.
  const popup = new mapboxgl.Popup({
      closeButton: true,
      closeOnClick: true
  });

  map.addChart = chart => {
    map.chart = chart;
    return map;
  };

  map.highlightMapLocation = (gage) => {
    const feature = map.querySourceFeatures( 'composite', { sourceLayer: 'div2_gages_filtered', filter: ["==", "DWRAbbrev", gage]})[0];

    if ( typeof feature !== "undefined" ) {
      const coords = feature.geometry.coordinates.slice();
      map.panTo(coords);

      if (popup instanceof mapboxgl.Popup) {
        popup.remove();
      }

      map.setFilter("div2-gages-filtered-hover", ["==", "DWRAbbrev", gage]);
      map.setLayoutProperty("div2-gages-filtered-hover", "visibility", "visible");

      loc.updateProps({ DWRAbbrev: feature.properties.DWRAbbrev, StatName: feature.properties.StatName });

      // Populate the popup and set its coordinates
      // based on the feature found.
      popup.setLngLat(coords)
        .setHTML(loc.generatePopupContent())
        .addTo(map);
    }
  } // map.highlightMapLocation()

  // Remove popup on mouse over
  map.on("mouseover", 'div2-gages-filtered', e => {
    // Change the cursor style as a UI indicator.
    map.getCanvas().style.cursor = 'pointer';

    const feature = e.features[0].properties;
    const gage = feature.DWRAbbrev;
    const coords = e.features[0].geometry.coordinates.slice();

    map.setFilter("div2-gages-filtered-hover", ["==", "DWRAbbrev", gage]);
    map.setLayoutProperty("div2-gages-filtered-hover", "visibility", "visible");

    loc.updateProps({ DWRAbbrev: feature.DWRAbbrev, StatName: feature.StatName });
    map.chart.generateTooltipLineFromMap(gage);

    // Populate the popup and set its coordinates
    // based on the feature found.
    popup.setLngLat(coords)
      .setHTML(loc.generatePopupContent())
      .addTo(map);

    // Update sidebar title
    sidebar.updateTitle( feature.DWRAbbrev);
  });

  // Remove popup on mouse leave
  // map.on('mouseleave', 'div2-gages-filtered', function() {
  //   map.getCanvas().style.cursor = '';
  //   popup.remove();
  // });

  return map;
};
